import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideOptimus } from '@openng/optimus-ui/config';
import { AuraCompact } from './shared/config/aura-compact.preset';
import { iconsProvider } from './shared/config/icons.config';
import { GANTT_GLOBAL_CONFIG, GanttI18nLocale, GANTT_I18N_LOCALE_TOKEN, GanttViewType } from '@worktile/gantt';
import { enUS } from 'date-fns/locale/en-US';

import { routes } from './app.routes';
import { GlobalErrorHandler } from './core/services/error-handler.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideOptimus({
      theme: {
        preset: AuraCompact,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authTokenInterceptor, authInterceptor, httpErrorInterceptor])),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    iconsProvider,
    {
      provide: GANTT_I18N_LOCALE_TOKEN,
      useValue: {
        id: GanttI18nLocale.enUs,
        dateLocale: enUS,
        views: {
          [GanttViewType.hour]: {
            label: 'Hour',
            dateFormats: {
              primary: 'MMM dd',
              secondary: 'HH:mm'
            }
          },
          [GanttViewType.day]: {
            label: 'Day',
            dateFormats: {
              primary: 'yyyy MMM',
              secondary: 'dd'
            }
          },
          [GanttViewType.week]: {
            label: 'Week',
            dateFormats: {
              primary: 'yyyy MMM',
              secondary: 'ww'
            }
          },
          [GanttViewType.month]: {
            label: 'Month',
            dateFormats: {
              primary: 'yyyy',
              secondary: 'MMM'
            }
          },
          [GanttViewType.quarter]: {
            label: 'Quarter',
            dateFormats: {
              primary: 'yyyy',
              secondary: 'QQQ'
            }
          },
          [GanttViewType.year]: {
            label: 'Year',
            dateFormats: {
              primary: 'yyyy',
              secondary: 'yyyy'
            }
          }
        }
      },
      multi: true
    },
    {
      provide: GANTT_GLOBAL_CONFIG,
      useValue: {
        locale: GanttI18nLocale.enUs,
        dateFormat: {
          yearQuarter: `yyyy-QQQ`
        }
      }
    }
  ]
};
